import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_BOOKINGS } from '../actions';
import { flattenBookingsToJobs } from '../api/DataHandlers';

const fetchBookingsEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_BOOKINGS).mergeMap(action =>
        Observable.from(api.fetchBookings(action.payload))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(response))
            .catch(() =>
                Observable.of(
                    actions.loadBookingsFailure('Problem loading shifts'),
                ),
            ),
    );

const toAction = response => {
    if (response) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return actions.loadBookingsSuccess(flattenBookingsToJobs(response.data));
    }
    return actions.loadBookingsFailure('Problem loading bookings');
};

export default fetchBookingsEpic;
